import { connect } from 'react-redux'
import Cover from './cover'
import { deleteCover } from '../../../../stores/school/school.actions'
import { withRouter } from 'react-router'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapDispatchToProps = (dispatch, { match }) => ({
  onDelete: state => dispatch(deleteCover(match.params.id)).catch(errorHandler)
})

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(Cover)
)
